import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, CloseIcon, DotDotDotVerticalIcon, MutedSpeakerIcon, StreamrNewLogoSolo, UnmutedSpeakerIcon, } from '@streamr/tv-ui';
import { useNavigate } from 'react-router';
import styled from 'styled-components';
import { BroadcastStateService } from '../../services/broadcaststate/BroadcastStateService';
import { StreamrAppService } from '../../services/streamrapp/StreamrAppService';
import { RequestToSpeakButton } from '../broadcaster/RequestToSpeakButton';
import { LiveIndicator } from '../LiveIndicator';
import { openViewerOptions } from '../popups/ViewerOptionsPopup';
import { ShareButtonRound } from '../ShareButtons';
import { BottomLeftSlot, BottomRightSlot, HudSlots, TopLeftSlot, TopRightSlot, } from '../shared/HudSlots';
import { LogoLink } from '../shared/LogoLink';
import { MobilePluginButtonTray } from '../shared/PluginButtonTray';
export function StreamrAppViewerViewMobileHud({ broadcastUrl, fullscreenButton, visible, }) {
    const isAudioOnMute = !!StreamrAppService.getOutput().useAudioMuted();
    const isVideoStreaming = StreamrAppService.getOutput().useIsVideoStreaming();
    const activeBroadcast = BroadcastStateService.getOutput().useRequiredActiveBroadcast();
    const navigate = useNavigate();
    return (_jsxs(StreamrAppViewerViewMobileHudRoot, { "$visible": visible, children: [_jsx(TopLeftSlot, { children: _jsx(LogoLink, { logoImage: _jsx(StreamrNewLogoSolo, {}) }) }), _jsx(TopRightSlot, { children: isVideoStreaming && _jsx(LiveIndicator, {}) }), _jsxs(StyledBottomLeftSlot, { children: [_jsx(MuteButton, { type: "button", onClick: () => {
                            StreamrAppService.getNotificationInterface().notifyToggleAudio();
                        }, "$isMuted": isAudioOnMute, children: isAudioOnMute ? (_jsx(MutedSpeakerIcon, {})) : (_jsx(UnmutedSpeakerIcon, {})) }), _jsx(CloseButton, { type: "button", onClick: () => {
                            navigate('/');
                        }, children: _jsx(CloseIcon, {}) }), _jsx(StyledButton, { type: "button", onClick: () => {
                            openViewerOptions({
                                activeBroadcast,
                                variant: 'mobile',
                            });
                        }, children: _jsx(DotDotDotVerticalIcon, {}) })] }), _jsxs(StyledBottomRightSlot, { children: [fullscreenButton, _jsx(ShareButtonRound, { url: broadcastUrl }), _jsx(RequestToSpeakButton, {}), _jsx(MobilePluginButtonTray, { slotId: "buttonstray" })] })] }));
}
const StreamrAppViewerViewMobileHudRoot = styled(HudSlots) `
    --tv-HudSlots-offset: 1rem;
    z-index: 10;
    opacity: ${({ $visible }) => ($visible ? 1 : 0)};
    transition: opacity 0.3s ease-in-out;
    pointer-events: none;
`;
const StyledBottomLeftSlot = styled(BottomLeftSlot) `
    --tv-HudBottomSlot-offset: 1rem;
`;
const StyledBottomRightSlot = styled(BottomRightSlot) `
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    align-items: flex-end;
    justify-content: center;
`;
const StyledButton = styled(Button) `
    --Button_Background: var(--tv-ui-color-12);
    --Button_HoverBackground: var(--tv-ui-color-12);
    --Button_TextColor: var(--tv-ui-color-3);
    --Button_BorderRadius: 1.5rem;
    --Button_Height: 3rem;
    --Button_Width: 3rem;
    backdrop-filter: blur(10px);
`;
const CloseButton = styled(StyledButton) `
    --Button_Background: var(--tv-ui-color-6);
    --Button_HoverBackground: var(--tv-ui-color-6);
`;
const MuteButton = styled(StyledButton) `
    --Button_Background: ${({ $isMuted }) => $isMuted ? 'var(--tv-ui-color-3)' : 'var(--tv-ui-color-12)'};
    --Button_HoverBackground: ${({ $isMuted }) => $isMuted ? 'var(--tv-ui-color-3)' : 'var(--tv-ui-color-12)'};
`;
